export default {
  name: 'cart',
  props: {
    application: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  computed: {
    cart () {
      return this.application.cart
    },
    params () {
      return this.application.params
    },
    queryParams () {
      return this.application.queryParams
    },
    goodList () {
      console.log(this.application.cart)
      return this.application.cart.GRID.ROWS
    }
  },
  methods: {
    onSubmit () {},
    onPhoneComplete () {},
    onVinComplete () {},
    removeProduct (id) {
      let params = new FormData()
      params.append('basketAction', 'recalculateAjax')
      params.append('basket[DELETE_' + id+']', 'Y')
      this.sendAjax(id, params).then(function () {
        window.basket.reload()
      })
    },
    delayProduct (id) {
      let params = new FormData()
      params.append('basketAction', 'recalculateAjax')
      params.append('basket[DELAY_' + id+']', 'Y')
      this.sendAjax(id, params)
      window.$('#delayedGoodModal').modal('show')
    },
    addProduct (id) {
      let params = new FormData()
      params.append('basketAction', 'recalculateAjax')
      params.append('basket[DELAY_' + id+']', 'N')
      this.sendAjax(id, params)
    },
    updateProductCount (id, count) {
      let params = new FormData()
      params.append('basketAction', 'recalculateAjax')
      params.append('basket[QUANTITY_' + id+']', count)
      this.sendAjax(id, params)
    },
    sendAjax (id, params) {
      let goodList = this.cart.GRID.ROWS
      for (const good in goodList) {
        if (!goodList.hasOwnProperty(good)) {
          continue
        }
        if (goodList[good].ID === id) {
          continue
        }
        if (goodList[good].DELAY === 'Y') {
          params.append('basket[DELAY_'  + goodList[good].ID+']', 'Y')
        }
      }
      for (const parameter in this.queryParams) {
        if (!this.queryParams.hasOwnProperty(parameter)) {
          continue
        }
        params.append(parameter, this.queryParams[parameter])
      }

      let vm = this
      return this.$http.post(this.application.ajaxUrl, params).then(function (response) {
        console.log(response)
        vm.application.cart = response.data['BASKET_DATA']
      }).catch(function (error) {
        console.log(error)
      })
    },
    getWord (sentence = '', number = 1) {
      return sentence.split(', ')[2]
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/components/cart/script.js